// extracted by mini-css-extract-plugin
module.exports = {"image":"Image-module--image--t1897"};